import {
  Avatar,
  AvatarFallback,
  AvatarImage
} from '@ps-design-system/components/Avatar';
import { Text } from '@ps-design-system/components/Text';
import PowerhostIcon from '@ps-design-system/icons/PowerHostFilled/PowerHostFilled16';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const HostAvatar = ({ hostAvatarUrl, hostFirstName, isPowerHost }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      <Avatar size={48}>
        <AvatarImage src={hostAvatarUrl} />
        <AvatarFallback />
      </Avatar>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Text typeface="headline-2-m">{hostFirstName}</Text>
        {isPowerHost && (
          <span
            style={{
              borderRadius: '50px',
              backgroundColor: '#E9EBEF',
              padding: '0px 8px',
              color: '#6A6E7A'
            }}
          >
            <PowerhostIcon />
            <Text typeface="body-1-m">
              <FormattedMessage
                id="host_avatar.power_host"
                defaultMessage="Power Host"
              />
            </Text>
          </span>
        )}
      </div>
    </div>
  );
};

HostAvatar.displayName = 'HostAvatar';
HostAvatar.propTypes = {
  hostAvatarUrl: PropTypes.string,
  hostFirstName: PropTypes.string,
  isPowerHost: PropTypes.bool
};
